// extracted by mini-css-extract-plugin
module.exports = {"Content":"Tooltip_Content__p24jC"};